export function LoadNotifications({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 176C128.719 176 152 171.971 152 167C152 162.029 128.719 158 100 158C71.2812 158 48 162.029 48 167C48 171.971 71.2812 176 100 176Z"
          fill="var(--clr-title)"
          fillOpacity="0.05"
        />
        <path
          opacity="0.9"
          d="M68.168 63.9157C70.1124 60.8103 72.6913 58.151 75.7354 56.112C78.7796 54.073 82.2203 52.7005 85.832 52.0843"
          stroke="var(--clr-inline-error)"
          strokeLinecap="round"
        />
        <path
          opacity="0.55"
          d="M125.619 79.1458C133.348 73.1291 138.6 64.4857 140.381 54.8542"
          stroke="var(--clr-inline-error)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="3 8"
        />
        <path
          d="M139.045 38L147.579 52.6684M150.646 41.0669L135.978 49.6015"
          stroke="var(--clr-inline-error)"
          strokeLinecap="round"
        />
        <path
          d="M100 60C77 60 64 78 62 104C60 126 53 138 44 147C40 151 43 156 49 156H151C157 156 160 151 156 147C147 138 140 126 138 104C136 78 123 60 100 60Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 53C101.857 53 103.637 53.7375 104.95 55.0503C106.262 56.363 107 58.1435 107 60H93C93 58.1435 93.7375 56.363 95.0503 55.0503C96.363 53.7375 98.1435 53 100 53Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 171.5C104.142 171.5 107.5 168.142 107.5 164C107.5 159.858 104.142 156.5 100 156.5C95.8579 156.5 92.5 159.858 92.5 164C92.5 168.142 95.8579 171.5 100 171.5Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path d="M80 96L93 100" stroke="var(--clr-general-description)" strokeLinecap="round" />
        <path d="M120 96L107 100" stroke="var(--clr-general-description)" strokeLinecap="round" />
        <path
          d="M87 111.2C88.7673 111.2 90.2 109.767 90.2 108C90.2 106.233 88.7673 104.8 87 104.8C85.2327 104.8 83.8 106.233 83.8 108C83.8 109.767 85.2327 111.2 87 111.2Z"
          fill="var(--clr-general-description)"
        />
        <path
          d="M113 111.2C114.767 111.2 116.2 109.767 116.2 108C116.2 106.233 114.767 104.8 113 104.8C111.233 104.8 109.8 106.233 109.8 108C109.8 109.767 111.233 111.2 113 111.2Z"
          fill="var(--clr-general-description)"
        />
        <path
          d="M92 124C97.3333 120 102.667 120 108 124"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.16"
          d="M78.5 119.5C80.1569 119.5 81.5 118.157 81.5 116.5C81.5 114.843 80.1569 113.5 78.5 113.5C76.8431 113.5 75.5 114.843 75.5 116.5C75.5 118.157 76.8431 119.5 78.5 119.5Z"
          fill="var(--clr-inline-error)"
        />
        <path
          opacity="0.16"
          d="M118.5 119.5C120.157 119.5 121.5 118.157 121.5 116.5C121.5 114.843 120.157 113.5 118.5 113.5C116.843 113.5 115.5 114.843 115.5 116.5C115.5 118.157 116.843 119.5 118.5 119.5Z"
          fill="var(--clr-inline-error)"
        />
      </svg>
    </span>
  );
}
